import React, { useState } from 'react';
import { Modal } from 'antd';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const LinkExpiryModal = ({ isOpen, onClose, onConfirm, testType, isLoading }) => {
  const [expiryDate, setExpiryDate] = useState(null);

  if (!isOpen) return null;

  return (
    <Modal
      title="Set Link Expiry"
      open={isOpen}
      onCancel={onClose}
      footer={[
      
        <div className='flex justify-end'>
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(expiryDate)}
            className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 disabled:opacity-50 flex items-center gap-2 ml-2"
          >
            Confirm
          </button>
        </div>
      ]}
      width={400}
      maskClosable={!isLoading}
      closable={!isLoading}
      centered
    >
      <div className="mb-7 w-full  ">
        <label className="block text-sm font-medium text-gray-700 mb-2 mt-5  ">
          Select Expiry Date and Time
        </label>
        <DatePicker
          selected={expiryDate}
          onChange={(date) => setExpiryDate(date)}
          showTimeSelect
          timeFormat="HH:mm"
          timeIntervals={15}
          dateFormat="MMMM d, yyyy h:mm aa"
          minDate={new Date()}
          className="w-[350px] p-2 border rounded-md bg-white"
          placeholderText="Click to select date and time"
          disabled={isLoading}
        />
      </div>
    </Modal>
  );
};

export default LinkExpiryModal; 